import React, { useState, useRef } from 'react';
import { loginUser } from '../../api/userApi';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReCAPTCHA from 'react-google-recaptcha';
import { useAuth } from '../../context/AuthContext';
import './LoginPage.css';
import HomeButton from '../common/HomeButton';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [failedAttempts, setFailedAttempts] = useState(Number(localStorage.getItem('failedLoginAttempts')) || 0);
  const [showRecaptcha, setShowRecaptcha] = useState(failedAttempts >= 2);
  const recaptcha = useRef();
  
  const RECAPTCHA_SITE_KEY = window.process.env.RECAPTCHA_SITE_KEY;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { email, password };
    if (showRecaptcha) {
      const captchaValue = recaptcha.current.getValue();

      if (!captchaValue) {
        setError(t('login.completeCaptcha'));
        recaptcha.current?.reset();
        return;
      }
      payload.recaptchaToken = captchaValue;
    }
    try {
      const data = await loginUser(payload);
      login(data);
      localStorage.removeItem('failedLoginAttempts');
      setFailedAttempts(0);
      navigate('/'); 
    } catch (error) {
      if (error.response && error.response.status === 403) {
        const resendConfirmationLink = () => (
          <div>
            <p>{t('login.errorEmailNotConfired')}</p>
            <button className='link-button' onClick ={() => navigate('/resend-confirmation')}>{t('login.resendConfirmation')}</button>
          </div>
        )
        setError(resendConfirmationLink());
      } else if (error.response && error.response.status === 429) {
        setError(t('login.tooManyRequests'))
      } else if (error.response.data.message === 'CAPTCHA verification failed') {
        setError(t('login.completeCaptcha'));  
      } else {
        const newFails = failedAttempts + 1;
        setFailedAttempts(newFails);
        localStorage.setItem('failedLoginAttempts', newFails);
        if (newFails >= 2) setShowRecaptcha(true);
        setError(t('login.errorCredential'));
      }
      recaptcha.current?.reset();
    }
  };

  return (
    <div className='login-page'>
      <HomeButton />
      <h2 className='login-h2'>{t('login.notRegistered')} <button className='link-button' onClick={() => navigate('/register')}>{t('login.registerHere')}</button></h2>
      {error && <p className='form-error'>{error}</p>}
      <form className='login-form' onSubmit={handleSubmit}>
        <div>
          <input type="email" placeholder={t('login.email')} value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <input type="password" placeholder={t('login.password')} value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {showRecaptcha && (<div className='captcha'>
          <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              ref={recaptcha}
              theme='dark'
          />
        </div>)}
        <div className='button-container'>
          <button className='big-button action-button' type="submit">
            <i className="fa-solid fa-right-to-bracket"></i>
            <span>{t('login.signIn')}</span>
          </button>
        </div>
        </form>
        <h3 className='login-h3'><button className='link-button' onClick={() => navigate('/forgot-password')}>{t('login.forgotPassword')}</button></h3>     
     
    </div>
  );

}

export default Login;
